<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13X3xkQ/tc-custom/9780253031228.jpg?1737166238459" alt="This image is the cover for the book From New York to San Francisco, Encounters: Explorations in Folklore and Ethnomusicology"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">From New York to San Francisco, Encounters: Explorations in Folklore and Ethnomusicology
      </h1>
      <p class="bookDescription body article font2">
        <b>A “fresh, wonderful, captivating” journey across 19th-century America through the letters of composer Felix Mendelssohn’s nephew </b><b>(alfemminile.blogspot.com).</b><br/>  <br/> Welcome to an America you’ve never seen. Where anyone can drop by the White House and visit the President between 10 a.m. and noon; where cowcatchers are bloodied daily on train tracks between New York and Boston; where spent bullets are strewn across Civil War battlefields, and Indians still roam Yosemite Valley; where pigs rut in the sand-and-clay streets of Washington, DC., and the weather-bleached skeletons of oxen and horses line the old mail roads across the West.<br/>  <br/> For three hot summer months in 1869, Ernst Mendelssohn-Barthody, the nephew of famed composer Felix Mendelssohn, traveled by train across the United States accompanied by his older cousin. His letters back home to Prussia offer fascinating glimpses of a young, rapidly growing America. Unceasingly annoyed at the Americans’ tendency to spit all the time, the Prussian aristocrats seemingly visited everyone and everywhere: meeting President Grant and Brigham Young; touring Niagara Falls, Mammoth Cave, the Redwoods, and Yosemite; taking in New York, Boston, Philadelphia, Chicago, Omaha, San Francisco, and the still war-ravaged city of Richmond; and crossing the continent by rail just two months after the Union Pacific and Central Pacific railroads had been joined at Promontory, Utah.<br/>  <br/> Full of marvelous tales and insightful observations, Ernst Mendelssohn-Barthody’s letters are a revealing window to a long-ago America.<br/>  <br/> “If you love epistolary genre and the USA and if you want to understand how Americans lived immediately after the Secession War, <i>From New York to San Francisco</i> is the book you were waiting for.”—alfemminile.blogspot.com
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ernst Mendelssohn-Bartholdy, Gertrud Graubart Champe, Barbara Thiem
      </h2>
      
      <p class="authorDescription body article">Barbara Haimberger Thiem is a performing cellist and teaches at Colorado State University. She spends the summers in Austria and Germany keeping up the tradition of gathering at Traunsee in the old family place, surrounded by immediate and more distant family members.Gertrud Graubart Champe, PhD, is a professional translator with an interest in European cultural history.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d3484b2e